import {NgModule} from '@angular/core';

import {MdcElevation} from './elevation';

@NgModule({
  exports: [MdcElevation],
  declarations: [MdcElevation]
})
export class MdcElevationModule { }
